__webpack_require__.p = "https://static-website.miro.com/miro-site-lp-build-assets/_next/";